<template funtional>
  <span>{{frequencyInWords}}</span>

</template>

<script>
export default {
  props: ['routine'],

  computed: {
    frequencyInWords () {
      if (this.routine.frequency_period === 'daily') {
        return 'daily'
      } else if (this.routine.frequency_count == 1) {
        return `at least once a ${this.routine.frequency_period}`
      } else {
        return `at least ${this.routine.frequency_count} times a ${this.routine.frequency_period}`
      }
    }
  }
}
</script>
